import { useEffect, useState } from 'react';
import { X, PhoneCall, ThumbsUp, ThumbsDown } from 'lucide-react';
import { api } from '../lib/api';

const KEY = 'tt_pending_calls';

export function trackCall(tradieId, tradieName) {
  try {
    const list = JSON.parse(localStorage.getItem(KEY) || '[]');
    // Dedupe: keep only if not already there in last 6 hours
    const now = Date.now();
    const kept = list.filter((c) => c.tradie_id !== tradieId && now - c.ts < 6 * 3600 * 1000);
    kept.push({ tradie_id: tradieId, tradie_name: tradieName, ts: now, prompted: false });
    localStorage.setItem(KEY, JSON.stringify(kept));
  } catch { /* ignore */ }
}

function readPending() {
  try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch { return []; }
}
function writePending(list) {
  localStorage.setItem(KEY, JSON.stringify(list));
}

export default function CallFeedbackPrompt() {
  const [call, setCall] = useState(null);

  useEffect(() => {
    const check = () => {
      const list = readPending();
      const now = Date.now();
      // Show a prompt for the oldest un-prompted call that's at least 30 seconds old
      const c = list.find((x) => !x.prompted && (now - x.ts) >= 30_000 && (now - x.ts) < 24 * 3600 * 1000);
      if (c) setCall(c);
    };
    check();
    const interval = setInterval(check, 5000);
    return () => clearInterval(interval);
  }, []);

  if (!call) return null;

  const finish = async (answered) => {
    const list = readPending().map((c) => c.tradie_id === call.tradie_id && c.ts === call.ts ? { ...c, prompted: true, answered } : c);
    writePending(list);
    setCall(null);
    if (answered !== null) {
      try { await api.callFeedback({ tradie_id: call.tradie_id, answered }); } catch { /* ignore */ }
    }
  };

  return (
    <div className="fixed bottom-6 right-6 z-40 w-[340px] border border-[#1C1B1A] bg-white p-5 shadow-[6px_6px_0_#1C1B1A]" data-testid="call-feedback-prompt">
      <div className="flex items-start justify-between">
        <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-[#1A362D]">
          <PhoneCall size={14} /> Quick question
        </div>
        <button onClick={() => finish(null)} className="text-[#8A8988] hover:text-[#1C1B1A]" aria-label="Dismiss">
          <X size={16} />
        </button>
      </div>
      <div className="mt-3 font-heading text-lg font-bold text-[#1C1B1A]">
        Did <span className="italic">{call.tradie_name}</span> answer your call?
      </div>
      <p className="mt-1 text-xs text-[#8A8988]">Your feedback helps other locals find tradies who actually pick up.</p>
      <div className="mt-4 flex gap-2">
        <button onClick={() => finish(true)} data-testid="feedback-yes" className="btn-primary flex-1 justify-center py-2 text-sm">
          <ThumbsUp size={14} /> Yes
        </button>
        <button onClick={() => finish(false)} data-testid="feedback-no" className="btn-secondary flex-1 justify-center py-2 text-sm">
          <ThumbsDown size={14} /> No
        </button>
      </div>
    </div>
  );
}
